(function () {
    'use strict';

    angular
        .module('franchisee-portal.constants', []);

    angular
        .module('franchisee-portal.components', []);

    angular
        .module('franchisee-portal.directives', []);

    angular
        .module('franchisee-portal.filters', []);

    angular
        .module('franchisee-portal.interceptors', []);

    angular
        .module('franchisee-portal.routes', []);

    angular
        .module('franchisee-portal.services', []);
}());